//
//
//
//
//
//

import ItemCard from "./ItemCard";
import {debounce} from '~/utils/utils';

const imagesLoaded = require('imagesloaded');
export default {
  components: {
    ItemCard
  },
  props: {
    pictures: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    addedAdvertising() {
      const arr = [...this.pictures]
      const closeImagesRU = {
        img: ['/app/images/zaglushka_2_ru.svg', '/app/images/zaglushka_1_ru.svg'],
        gif: ['/app/images/zaglushka_2_ru.gif', '/app/images/zaglushka_1_ru.gif']
      }
      const closeImagesEN = {
        img: ['/app/images/zaglushka_2_en.svg', '/app/images/zaglushka_1_en.svg'],
        gif: ['/app/images/zaglushka_2_en.gif', '/app/images/zaglushka_1_en.gif']
      }

      if (this.$route.query.canPatron) {
        return arr
      }

      const max = arr.length > 11 ? 2 : arr.length > 5 ? 1 : 0
      const middle = Math.ceil(arr.length / 2)

      for (let i = 0; i < max; i++) {
        const random = Math.ceil(Math.random() * middle)
        let closed
        const randomImg = Math.floor(Math.random() * closeImagesRU.length)
        if (this.$i18n.locale === 'en') {
          closed = {
            picture: closeImagesEN.img.splice(randomImg, 1),
            openDonat: true,
            pictureGif: closeImagesEN.gif.splice(randomImg, 1),
          }
        } else {
          closed = {
            picture: closeImagesRU.img.splice(randomImg, 1),
            openDonat: true,
            pictureGif: closeImagesRU.gif.splice(randomImg, 1),
          }
        }
        arr.splice(random + (middle * i), 0, closed)
      }
      return arr
    }
  },
  mounted() {
    this.$store.commit('changeGalleryQuery', this.$route.fullPath)
    this.resizeAllGridItems();
    window.addEventListener("resize", this.resizeAllGridItems);
    const allItems = document.getElementsByClassName("picture-card");
    for (let x = 0; x < allItems.length; x++) {
      imagesLoaded(allItems[x], this.resizeInstance);
      let node = allItems[x].querySelector('.image-item')
      if (!!node) {
        allItems[x].querySelector('.image-item').onload = () => {
          this.resizeGridItem(allItems[x]);
        }
      }
    }
    imagesLoaded(this.$refs.galleryList, (instance) => {
      this.$emit('loaded')
      this.resizeAllGridItems()
    });
    // this.timer = setInterval(() => {
    //   this.resizeAllGridItems()
    // }, 2000)
  },
  beforeDestroy() {
    // if (this.timer) {
    //   clearInterval(this.timer)
    // }
    window.removeEventListener("resize", this.resizeAllGridItems);
  },
  methods: {
    resizeGridItem(item) {
      const grid = document.querySelector(".gallery");
      if (!grid) return
      const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      const rowSpan = Math.ceil(item.querySelector('.picture-content').offsetHeight / rowHeight);
      item.style.gridRowEnd = `span ${rowSpan}`;
    },

    resizeAllGridItems: debounce(function () {
      let allItems = document.getElementsByClassName("picture-card");
      for (let x = 0; x < allItems.length; x++) {
        this.resizeGridItem(allItems[x]);
        imagesLoaded(allItems[x], this.resizeInstance);
      }
    }, 50),

    resizeInstance(instance) {
      const item = instance.elements[0];
      this.resizeGridItem(item);
      // item.style.opacity = 1
    }
  }
}
